<template>
  <div>
    <data-table-consulta-comp
      :colNames="colNames"
      :eventBusDataName="eventBusDataName"
      :eventBusDataPaginationName="eventBusPaginationName"
      :dataTableColumn="dataTableColumn"
      :colWidth="colWidth">
      <template v-slot="slotProps">
        <td style="text-align: center; width: 100px !important; white-space: nowrap;">
          <i
            v-tooltip.auto-start="`Atribuir a ${slotProps.itemData.NomeUsuario}`"
            class="fa fa-link fa-1-5x m-1 link text-info"
            aria-hidden="true"
            v-on:click="atribuir(slotProps.itemData)"
          ></i>
        </td>
      </template>
    </data-table-consulta-comp>
  </div>
</template>

<script>
import VirtusService from '@/services/VirtusService'
import UsuarioService from '@/services/UsuarioService'

import dataTableConsultaComp from '@/components/data-table-consulta/DataTableConsultaComp'
import eventBus from '@/uteis/eventBus'

export default {
  name: 'atribuirPara',

  components: {
    dataTableConsultaComp
  },

  props: {
    eventBusModal: { required: true, type: String },
    closeModalEvent: { required: true, type: Function },
    rowsNumber: { required: true, type: Number }
  },

  data () {
    return {
      colNames: ['Nome', 'Usuário', 'Ações'],
      colWidth: [50, 30, 20],
      dataTableColumn: [
        'NomeUsuario', 'Login'
      ],
      eventBusDataName: 'consultaUsuariosNoSetor',
      eventBusPaginationName: 'consultaUsuariosNoSetorDataPagination'
    }
  },

  created () {
    this.virtusService = new VirtusService()
    this.usuarioService = new UsuarioService()

    this.pesquisar()

    eventBus.$on(this.eventBusPaginationName, (numeroPagina) => {
      this.pesquisar(numeroPagina)
    })
  },

  methods: {
    pesquisar (page = 1) {
      const dadosSessao = this.$store.getters.getDadosSessao
      this.usuarioService.buscarUsuarios({
        ...dadosSessao,
        offset: page,
        range: this.rowsNumber
      }).then(res => {
        eventBus.$emit(this.eventBusDataName, res)
      }).catch(err => {
        console.log(err)
      })
    },

    atribuir (usuarioAtribuido) {
      const login = `${usuarioAtribuido.UsuarioID}@${usuarioAtribuido.Login.toLowerCase()}@${usuarioAtribuido.Dominio.toLowerCase()}`
      const processos = this.$store.getters.getDataTableChecked
      const dadosDaSessao = { ...this.$store.getters.getDadosSessao.sessao }
      const dadosDaSessaoParaUsuarioAtribuidor = { ...dadosDaSessao }
      const sessao = {
        ...dadosDaSessao,
        nomeUsuario: usuarioAtribuido.NomeUsuario,
        login: login
      }
      try {
        processos.flatMap(async (processoMapeado) => {
          await Promise.all([
            this.virtusService.registrarAtribuicaoNoHistorico(dadosDaSessaoParaUsuarioAtribuidor,
              sessao, processoMapeado.data.processo),
            this.virtusService.atribuirProcessos(processoMapeado, sessao)
          ])
          eventBus.$emit(this.eventBusModal)
        })
      } catch (err) {
        console.error(err)
      }

      this.closeModalEvent()
    },

    closeModal () {
    }
  },

  destroyed () {
    eventBus.$off(this.eventBusPaginationName)
  }
}
</script>
